'use memo';

import { Outlet, createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { FillScreen } from '@/components/Layout';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { DeviceAssignmentAlertCategorySidebar } from './-components/DeviceAssignmentAlertCategorySidebar';
import { useDeviceAssignmentAlertCountsQuery } from './-query';
import { DeviceAssignmentAlertsSearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_staff/devices/_list/alerts/_alerts')({
  validateSearch: zodValidator(DeviceAssignmentAlertsSearchSchema),
  component: RouteComponent
});
function RouteComponent() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.devices.alerts'
  });
  useDocumentTitle(t('pageTitle'));
  const countsQuery = useDeviceAssignmentAlertCountsQuery();
  return <FillScreen className="flex min-h-0 overflow-hidden">
      <DeviceAssignmentAlertCategorySidebar counts={countsQuery.data} />
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
        <Outlet />
      </div>
    </FillScreen>;
}